var Color = {

  // make given hex darker or lighter
  // http://www.sitepoint.com/javascript-generate-lighter-darker-color/
  colorLuminance: function(hex, lum) {

    // validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
    }
    lum = lum || 0;

    // convert to decimal and change luminosity
    var rgb = "#", c, i;
    for (i = 0; i < 3; i++) {
      c = parseInt(hex.substr(i*2,2), 16);
      c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
      rgb += ("00"+c).substr(c.length);
    }

    return rgb;
  },

  // Name that color from the current colors we know
  // Yellow by default
  getColorName: function(hex){
    switch(hex){
      case "#ff7979": return i18n.t("highlighters.red");
      case "#80e1fd": return i18n.t("highlighters.blue");
      case "#47e6b4": return i18n.t("highlighters.teal");
      case "#f4ed75": return i18n.t("highlighters.yellow");
      case "#ffa0ea": return i18n.t("highlighters.pink");
      case "#aca6ff": return i18n.t("highlighters.purple");
      case "#e5be8b": return i18n.t("highlighters.brown");
      case "#a1ec80": return i18n.t("highlighters.green");
      case "#ffc766": return i18n.t("highlighters.orange");
      case "#8ac6ff": return i18n.t("highlighters.darkblue");
      default: return i18n.t("highlighters.yellow");
    }
  }

};

module.exports = Color;
